

export class VehicleGroupActiveWithoutStatusOutput implements IVehicleGroupActiveWithoutStatusOutput {
    /** The auto-generated id of the vehicle group master */
    vehicle_group_id!: number;
    /** The vehicle group name with 255 character limit */
    vehicle_group_name!: string;

    constructor(data?: IVehicleGroupActiveWithoutStatusOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicle_group_id = _data["vehicle_group_id"];
            this.vehicle_group_name = _data["vehicle_group_name"];
        }
    }

    static fromJS(data: any): VehicleGroupActiveWithoutStatusOutput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleGroupActiveWithoutStatusOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicle_group_id"] = this.vehicle_group_id;
        data["vehicle_group_name"] = this.vehicle_group_name;
        return data; 
    }
}

export interface IVehicleGroupActiveWithoutStatusOutput {
    /** The auto-generated id of the vehicle group master */
    vehicle_group_id: number;
    /** The vehicle group name with 255 character limit */
    vehicle_group_name: string;
}

